export const ENVIAR_DOCUMENTOS = "@recepcion-documental/ENVIAR_DOCUMENTOS";
export const DOCUMENTOS_ENVIADOS = "@recepcion-documental/DOCUMENTOS_ENVIADOS";
export const ERROR_DOCUMENTOS_ENVIADOS = "@recepcion-documental/ERROR_DOCUMENTOS_ENVIADOS";
export const LIMPIAR_ENVIO_DOCUMENTOS = "@recepcion-documental/LIMPIAR_ENVIO_DOCUMENTOS";
